import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Devices(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Devices", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.1622 36.6486V13.6432c0-.4358-.174-.8537-.4836-1.1619-.3097-.3082-.7296-.4813-1.1675-.4813h-14.86c-.4379 0-.8579.1731-1.1675.4813-.3096.3082-.4836.7261-.4836 1.1619v23.0054h18.1622Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36 14H20v18h16V14Zm-7.3766 21.3512c.5373 0 .9729-.4356.9729-.973 0-.5373-.4356-.9729-.9729-.9729-.5374 0-.973.4356-.973.9729 0 .5374.4356.973.973.973Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.9745 21.7295h16.7568c.4444 0 .8706.1757 1.1848.4885.3143.3128.4908.7371.4908 1.1794v10.0078H4.29883V23.3974c0-.4423.17654-.8666.49079-1.1794.31425-.3128.74047-.4885 1.18488-.4885Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M22.4609 32v-8.9731H6.24472V32H22.4609Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3 33.4053h23.3514v1.6216c0 .4301-.1758.8425-.4886 1.1467-.3128.3041-.737.4749-1.1794.4749H4.66795c-.44237 0-.86662-.1708-1.17942-.4749C3.17573 35.8694 3 35.457 3 35.0269v-1.6216Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M15.9738 33.4052h-3.2432v1.946h3.2432v-1.946Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.5753 18.4863h7.8764c.4178 0 .8185.174 1.1139.4836.2955.3097.4614.7296.4614 1.1675v1.6511H34v-1.6511c0-.4379.166-.8578.4614-1.1675.2954-.3096.6961-.4836 1.1139-.4836ZM34 33.3463h11.027v1.6511c0 .4379-.1659.8579-.4614 1.1675-.2954.3096-.6961.4836-1.1139.4836h-7.8764c-.4178 0-.8185-.174-1.1139-.4836-.2954-.3096-.4614-.7296-.4614-1.1675v-1.6511Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M45 20H34v15h11V20Z", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx("path", { d: "M38 20h3v.5h-3V20Z", fill: theme.vars.palette.primary.dark })
  ] });
}
Devices.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Devices"
};
validateTidalLicense();
export {
  Devices
};
//# sourceMappingURL=Devices.js.map
